import React from 'react';
import { Link } from 'react-router-dom';

/**
 * Site footer. Renders a single horizontal bar with copyright on the left
 * and policy / contact links on the right.
 *
 * On narrow viewports the two halves stack vertically (handled in
 * primitives.css via the .footer media query).
 */
const Footer = () => {
  const year = new Date().getFullYear();

  return (
    <footer className="footer" role="contentinfo">
      <div>© {year} PlatformOpsLab. All rights reserved.</div>

      <nav className="footer__links" aria-label="Footer">
        <Link to="/about">About</Link>
        <Link to="/privacy-policy">Privacy Policy</Link>
        <Link to="/terms-of-service">Terms of Service</Link>
        <Link to="/contact">Contact</Link>
      </nav>
    </footer>
  );
};

export default Footer;